import React from 'react'
import { Box } from '@mui/material'
import { pointText } from '../../../lib/rule'

const PlayerCorrect = ({ simple, rule, label }) => {
  const pt = pointText(simple)

  const point = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {pt}
      </Box>
    </>
  )

  const above = value => (
    <Box component="span" className="rule-above">
      {value ? '以上' : '以下'}
    </Box>
  )

  const consBonus = () => {
    if (rule.pointCorrect === 1) {
      return (
        <>
          N連答で{point('N')}
        </>
      )
    } else {
      return (
        <>
          N連答で{point(`${rule.pointCorrect}×N`)}
        </>
      )
    }
  }

  const survival = () => {
    const sc = rule.specialCorrect
    if (rule.pointCorrect > 0) {
      return (
        <>
          {point(rule.initPoint)}{above(true)}ならば他の人全員に{point(sc.survival.value)}, そうでなければ{point(rule.pointCorrect)}
        </>
      )
    } else {
      return (
        <>
          他の人全員に{point(sc.survival.value)}
        </>
      )
    }
  }

  const sc = rule.specialCorrect
  const list = [(
    rule.pointCorrect !== 0 && !sc.consBonus && !sc.survival.active &&
    <Box component="span" className="rule-content" key="point-correct">
      {point(rule.pointCorrect)}
    </Box>
  ), (
    sc.consBonus &&
    <Box component="span" className="rule-content" key="cons-bonus">
      {consBonus()}
    </Box>
  ), (
    sc.survival.active &&
    <Box component="span" className="rule-content" key="survival">
      {survival()}
    </Box>
  )].filter(e => e)

  return list.length > 0 && (
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">{label || '正解'}</Box>
      {list}
    </Box>
  )
}

export default PlayerCorrect
